export function computeTax(config, provinceCode, taxableBase) {
  const base = Math.max(Number(taxableBase) || 0, 0);
  if (!config || !config.enabled || !provinceCode) return { rate: 0, amount: 0, breakdown: [], province: provinceCode || "", province_name: "" };
  const prov = (config.provinces || []).find((p) => p.code === provinceCode);
  if (!prov || prov.enabled === false) return { rate: 0, amount: 0, breakdown: [], province: provinceCode, province_name: "" };
  let amount = 0, rate = 0;
  const breakdown = (prov.components || []).map((c) => {
    const amt = +(base * c.rate / 100).toFixed(2);
    amount = +(amount + amt).toFixed(2);
    rate = +(rate + c.rate).toFixed(3);
    return { name: c.name, rate: c.rate, amount: amt };
  });
  return { rate, amount, breakdown, province: provinceCode, province_name: prov.name };
}
